import type { Root } from './prototypeTypes';

export interface AudioPlaybackVisualState {
	topicId?: string;
	chapterIndex?: number;
	/** Known target-chapter title for the optimistic rail relabel. */
	chapterTitle?: string;
	paused: boolean;
	ended?: boolean;
}

const intents = new WeakMap<object, AudioPlaybackVisualState>();

export function setOptimisticAudioPlayback(root: Root, state: AudioPlaybackVisualState): void {
	intents.set(root as unknown as object, state);
}

export function clearOptimisticAudioPlayback(root: Root): void {
	intents.delete(root as unknown as object);
}

/** A late request may only clear the optimistic state it originally owned. */
export function clearOptimisticAudioPlaybackForTarget(
	root: Root,
	target: Pick<AudioPlaybackVisualState, 'topicId' | 'chapterIndex'>,
): boolean {
	const current = intents.get(root as unknown as object);
	if (!current || current.topicId !== target.topicId || current.chapterIndex !== target.chapterIndex) return false;
	intents.delete(root as unknown as object);
	return true;
}

export function optimisticAudioPlayback(root: Root): AudioPlaybackVisualState | undefined {
	return intents.get(root as unknown as object);
}

export function resolveAudioPlaybackVisualState(root: Root, actual: AudioPlaybackVisualState): AudioPlaybackVisualState {
	const intent = intents.get(root as unknown as object);
	if (!intent) return actual;
	const sameTarget = intent.topicId === actual.topicId && intent.chapterIndex === actual.chapterIndex;
	if (sameTarget && (actual.ended || actual.paused === intent.paused)) {
		intents.delete(root as unknown as object);
		return actual;
	}
	return intent;
}
